import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

@Component({
  selector: 'app-qr-code-status',
  templateUrl: './qr-code-status.component.html',
  styleUrls: ['./qr-code-status.component.scss'],
})
export class QrCodeStatusComponent implements OnInit {
  status = false;
  response: any = {};
  prmsnID;
  options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  checkinDetails = {
    check_in_oxygen: '',
    check_in_temp: '',
    id: '',
  };
  constructor(
    private route: ActivatedRoute,
    public httpPolicy: PoliciesService,
    private notify: NotificationService,
    private location: Location
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.prmsnID = params.get('id');
    });
  }

  ngOnInit(): void {
    this.checkQRCodeStatus();
  }
  success(pos) {
    let crd = pos.coords;
    console.log('Your current position is:', crd);
    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);
  }

  error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  // navigator.geolocation.getCurrentPosition(success, error, options);

  checkQRCodeStatus(): void {
    const params = {
      prmsnID: this.prmsnID,
      lat: 22.997814664692218, //28.38655183934613,
      long: 72.49889549010803, //77.31682306036227,
    };
    this.httpPolicy.qrCodeStatus(params).subscribe((res) => {
      this.response = res;
      this.checkinDetails.id = this.response.seat.id;
    });
  }

  submitCheckinDetail(): void {
    if (!this.checkinDetails.id) {
      this.notify.showError('Booking ID is missing', 'Info!');
      return;
    }
    if (!this.checkinDetails.check_in_oxygen) {
      this.notify.showError('Please Enter Oxygen Level', 'Info!');
      return;
    }

    if (!this.checkinDetails.check_in_temp) {
      this.notify.showError('Please Enter temprature', 'Info!');
      return;
    }

    this.httpPolicy
      .checkInDetailSubmit(this.checkinDetails)
      .subscribe((res) => {
        if (res.status) {
          // this.checkQRCodeStatus();
          this.location.back();
          this.checkinDetails.check_in_oxygen = '';
          this.checkinDetails.check_in_temp = '';
          this.notify.showSuccess(res.msg, 'Success!');
        } else {
          this.notify.showError(res.msg, 'Error!');
        }
      });
  }
}
